export const labels = {
	horizontalAlignmentTooltip: {
		label: "Label.MobileCreator.Tooltip.HorizontalAlignment",
		default: "Horizontal alignment",
	},
	verticalAlignmentTooltip: {
		label: "Label.MobileCreator.Tooltip.VerticalAlignment",
		default: "Vertical alignment",
	},
} as const;
